import React, { useEffect, useState } from 'react';

const SEARCH_STEPS = [
  'Searching indexed papers',
  'Querying CoralFuture data',
  'Checking maps and CoRTAD',
  'Reading figures and citations',
];

const ChatThinking = ({ mode = 'search' }) => {
  const [step, setStep] = useState(0);

  useEffect(() => {
    if (mode !== 'search') return undefined;
    const timer = window.setInterval(() => {
      setStep((current) => (current + 1) % SEARCH_STEPS.length);
    }, 1600);
    return () => window.clearInterval(timer);
  }, [mode]);

  const label = mode === 'search' ? SEARCH_STEPS[step] : 'Writing answer';

  return (
    <div className={`chat-thinking chat-thinking-${mode}`} role="status" aria-live="polite">
      <img src="/chat-logo.png" alt="" className="chat-thinking-logo" />
      <div className="chat-thinking-copy">
        <div className="chat-thinking-label">
          {label}
          <span className="chat-thinking-dots" aria-hidden="true">
            <span />
            <span />
            <span />
          </span>
        </div>
        {mode === 'search' && (
          <div className="chat-thinking-track">
            <div className="chat-thinking-bar" />
          </div>
        )}
      </div>
    </div>
  );
};

export default ChatThinking;
